import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../insightConfig/insightConfig';
import "../ReusableComponent/CIVIL/CivilrightSection/CivilrightSection.css";

function ImageComponent1({ componentName }) {
    const [banners, setBanners] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const apiPrefix = componentName === "neet" ? "neet" : "cuet";
                const response = await axios.get(`${BASE_URL}/${apiPrefix}/user/practice-test-banners`);
                if (response.data && response.data.statusCode === 200) {
                    setBanners(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching practice test banners:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBanners();
    }, []);

    if (isLoading) {
        return (
            <div className="card-body px-0 py-4 d-flex justify-content-center align-items-center" style={{ minHeight: '150px' }}>
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!banners || banners.length === 0) {
        return null; // hide completely if no banners are returned after loading
    }

    return (
        <>
            <div>
                {banners.map((banner) => (
                    <div key={banner.Sn} className="card-body px-0 py-2 text-center">
                        <Link to={banner.Link} className='img-link'>
                            <img 
                                src={banner.ImageUrl} 
                                className="img-civil-border" 
                                alt={banner.Title || "Practice Test Banner"} 
                                style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                            />
                        </Link>
                    </div>
                ))}
            </div>
        </>
    );
}

export default ImageComponent1;